import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { ReturnsChart } from '@/components/charts/ReturnsChart';

export interface ChartDataPoint {
  ticker: string;
  dates: string[];
  values: number[];
  valuesWithoutDrip?: number[] | null;
}

export interface ChartModalProps {
  isOpen: boolean;
  onClose: () => void;
  ticker: string;
  chartData: ChartDataPoint | null;
  initialInvestment: number;
}

export function ChartModal({ isOpen, onClose, ticker, chartData, initialInvestment }: ChartModalProps) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50" />
        <Dialog.Content className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
          w-[90vw] max-w-4xl max-h-[85vh]
          bg-card rounded-lg shadow-xl p-6 z-50 overflow-auto
          border border-border">
          <Dialog.Title className="text-xl font-semibold text-foreground mb-4">
            {ticker} - Historical Performance
          </Dialog.Title>
          <Dialog.Description className="sr-only">
            Historical performance chart for {ticker}
          </Dialog.Description>

          <Dialog.Close className="absolute top-4 right-4 p-2 rounded-md
            hover:bg-muted text-muted-foreground hover:text-foreground
            focus:outline-none focus:ring-2 focus:ring-ring transition-colors">
            <X className="h-5 w-5" />
            <span className="sr-only">Close</span>
          </Dialog.Close>

          {chartData ? (
            <ReturnsChart
              data={[chartData]}
              initialInvestment={initialInvestment}
              height={400}
              title=""
            />
          ) : (
            <div className="flex items-center justify-center h-64 text-muted-foreground">
              No chart data available
            </div>
          )}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export default ChartModal;
